import React, {Fragment, useCallback, useEffect, useState} from 'react';
import './App.css';
import {Unity, useUnityContext} from "react-unity-webgl";
import {StatSheetRealm} from "./Components/realm.component";

const statsheetRealm = new StatSheetRealm();

function App() {
    const [width, setWidth] = useState(window.innerWidth);
    const [height, setHeight] = useState(window.innerHeight);
    const aspectRatio = 16 / 9;
    
    const {
        unityProvider,
        loadingProgression,
        isLoaded,
        sendMessage,
        addEventListener,
        removeEventListener,
        UNSAFE__unityInstance
    } = useUnityContext({
        loaderUrl: "Build/Build/Build.loader.js",
        dataUrl: "Build/Build/Build.data",
        frameworkUrl: "Build/Build/Build.framework.js",
        codeUrl: "Build/Build/Build.wasm",
    });


    const handleLoginInAnonymousCallback = useCallback(async (objectName: string, callback: string, fallback: string) => await statsheetRealm.LoginInAnonymousCallback(objectName, callback, fallback), []);
    const handleLoginEmailPasswordCallback = useCallback(async (objectName: string, callback: string, fallback: string, email: string, password: string) => await statsheetRealm.LoginEmailPasswordCallback(objectName, callback, fallback, email, password), []);
    const handleLoginUserPassCallback = useCallback(async (objectName: string, callback: string, fallback: string, email: string, password: string) => await statsheetRealm.LoginUserPassCallback(objectName, callback, fallback, email, password), []);
    const handleRegisterEmailPasswordCallback = useCallback(async (objectName: string, callback: string, fallback: string, email: string, password: string) => await statsheetRealm.RegisterEmailPasswordCallback(objectName, callback, fallback, email, password), []);
    const handleRealmSaveCallback = useCallback(async (objectName: string, callback: string, fallback: string, data: string, collectionName: string) => await statsheetRealm.RealmSaveCallback(objectName, callback, fallback, data, collectionName), []);
    const handleRealmDeleteProfileCallback = useCallback(async (objectName: string, callback: string, fallback: string, data: string) => await statsheetRealm.RealmDeleteProfileCallback(objectName, callback, fallback, data), []);
    const handleRealmDeleteItemCallback = useCallback(async (objectName: string, callback: string, fallback: string, data: string) => await statsheetRealm.RealmDeleteItemCallback(objectName, callback, fallback, data), []);
    const handleRealmDeleteSpellCallback = useCallback(async (objectName: string, callback: string, fallback: string, data: string) => await statsheetRealm.RealmDeleteSpellCallback(objectName, callback, fallback, data), []);
    const handleGetAllProfilesCallback = useCallback(async (objectName: string, callback: string, fallback: string, ownerId: string) => await statsheetRealm.GetAllProfilesCallback(objectName, callback, fallback, ownerId), []);
    const handleGetAllItemsCallback = useCallback(async (objectName: string, callback: string, fallback: string, ownerId: string) => await statsheetRealm.GetAllItemsCallback(objectName, callback, fallback, ownerId), []);
    const handleGetAllSpellsCallback = useCallback(async (objectName: string, callback: string, fallback: string, ownerId: string) => await statsheetRealm.GetAllSpellsCallback(objectName, callback, fallback, ownerId), []);
    const handleInitializeRealmCallback = useCallback(async (objectName: string, callback: string, fallback: string) => await statsheetRealm.InitializeRealmCallback(objectName, callback, fallback), []);
    const handleExecuteFunctionCallback = useCallback(async (objectName: string, callback: string, fallback: string, functionName: string, parameter: string) => await statsheetRealm.ExecuteFunctionCallback(objectName, callback, fallback, functionName, parameter), []);
    const handleGenerateNewIdCallback = useCallback(async (objectName: string, callback: string, fallback: string) => await statsheetRealm.GenerateNewIdCallback(objectName, callback, fallback), []);
    const handleOpenIndexDBCallback = useCallback(async (objectName: string, callback: string, fallback: string) => await statsheetRealm.OpenIndexDBCallback(objectName, callback, fallback), []);
    const handleSaveImageCallback = useCallback(async (objectName: string, callback: string, fallback: string, fileName: string, imageData: string) => await statsheetRealm.SaveImageCallback(objectName, callback, fallback, fileName, imageData), []);
    const handleDownloadImageCallback = useCallback(async (objectName: string, callback: string, fallback: string, fileName: string, imageData: string) => await statsheetRealm.DownloadImageCallback(objectName, callback, fallback, fileName, imageData), []);
    const handleLoadImageCallback = useCallback(async (objectName: string, callback: string, fallback: string, fileName: string, chunkIndex: string) => await statsheetRealm.LoadImageCallback(objectName, callback, fallback, fileName, chunkIndex), []);
    const handleHasImageCallback = useCallback(async (objectName: string, callback: string, fallback: string, fileName: string) => await statsheetRealm.HasImageCallback(objectName, callback, fallback, fileName), []);
    const handleRealmRefreshCallback = useCallback(async (objectName: string, callback: string, fallback: string) => await statsheetRealm.RealmRefreshCallback(objectName, callback, fallback), []);
    const handleSetClipboardCallback = useCallback(async (objectName: string, callback: string, fallback: string, text: string) => await statsheetRealm.SetClipboardCallback(objectName, callback, fallback, text), []);
    const handleGetClipboardCallback = useCallback(async (objectName: string, callback: string, fallback: string) => await statsheetRealm.GetClipboardCallback(objectName, callback, fallback), []);
    const handleOpenUrlCallback = useCallback(async (objectName: string, callback: string, fallback: string, url: string, download: boolean) => await statsheetRealm.OpenUrlCallback(objectName, callback, fallback, url, download), []);
    const handleGoogleAuthCallback = useCallback(async (objectName: string, callback: string, fallback: string, data: string) => await statsheetRealm.GoogleAuthCallback(objectName, callback, fallback, data), []);
    const handleGoogleLogoutCallback = useCallback(async (objectName: string, callback: string, fallback: string, data: string) => await statsheetRealm.GoogleLogoutCallback(objectName, callback, fallback, data), []);
    const handleGoogleIsSignedInCallback = useCallback(async (objectName: string, callback: string, fallback: string, data: string) => await statsheetRealm.GoogleIsSignedInCallback(objectName, callback, fallback, data), []);

    const handleWebGlConnected = useCallback(async (data: any) => {
        console.log("React WebGLConnectedCallback", data.detail);
        statsheetRealm.sendMessage?.("RealmWrapper", "WebGLConnectedCallback", JSON.stringify(data.detail));
    }, []);


    /*// Initialize Google API and set up auth instance
    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://accounts.google.com/gsi/client';
        script.async = true;
        script.defer = true;
        script.onload = () => {
            const currentWindow = window as any;
            currentWindow.gapi.load('auth2', () => {
                currentWindow.gapi.auth2.init({
                    client_id: '237330056930-ovunrbr1ecmoqq2nkrrjknl37tt38k0l.apps.googleusercontent.com',
                });
            });
        };
        document.head.appendChild(script);

        return () => {
            document.head.removeChild(script);
        };
    }, []);*/

    // Set the Unity instance as soon as it's available
    useEffect(() => {
        if (isLoaded) {
            (window as any).nethereumUnityInstance = UNSAFE__unityInstance;
            console.log('set window.nethereumUnityInstance to ', UNSAFE__unityInstance);
        }
    }, [isLoaded, UNSAFE__unityInstance]);
    
    useEffect(() => {
        const handleResize = () => {
            const newWidth = window.innerWidth;
            const newHeight = window.innerHeight;

            if (newWidth / newHeight > aspectRatio) {
                setWidth(newHeight * aspectRatio);
                setHeight(newHeight);
            } else {
                setWidth(newWidth);
                setHeight(newWidth / aspectRatio);
            }
        };

        document.addEventListener('paste', async (event) => {
            event.preventDefault();
            const clipboardData = event.clipboardData;
            console.log("React paste", clipboardData);
            if (clipboardData) {
                const items = Array.from(clipboardData.items); // Convert DataTransferItemList to array
                items.forEach(item => {
                    console.log("React paste item", item);
                    if (item.type.startsWith('image/')) {
                        const blob = item.getAsFile();
                        if (!blob) return;
                        const reader = new FileReader();
                        reader.onload = function(e) {
                            if (!e.target) return;
                            let base64Image = e.target.result;

                            if (base64Image === null) return;

                            if (typeof base64Image !== 'string') {
                                base64Image = new TextDecoder().decode(new Uint8Array(base64Image));
                            }
                            console.log("React paste image", base64Image);
                            statsheetRealm.clipBoardData = base64Image;
                        };
                        reader.readAsDataURL(blob);
                    } else if (item.kind === 'string') {
                        item.getAsString(text => {
                            console.log("React paste text", text);
                            statsheetRealm.clipBoardData = text;
                        });
                    }
                });
            }
        });

        handleResize();
        if (sendMessage) statsheetRealm.sendMessage = sendMessage;
        addEventListener("LoginInAnonymousCallback", handleLoginInAnonymousCallback);
        addEventListener("LoginInEmailPasswordCallback", handleLoginEmailPasswordCallback);
        addEventListener("LoginUserPassCallback", handleLoginUserPassCallback);
        addEventListener("RegisterEmailPasswordCallback", handleRegisterEmailPasswordCallback);
        addEventListener("ReactSaveCallback", handleRealmSaveCallback);
        addEventListener("ReactDeleteProfileCallback", handleRealmDeleteProfileCallback);
        addEventListener("ReactDeleteItemCallback", handleRealmDeleteItemCallback);
        addEventListener("ReactDeleteSpellCallback", handleRealmDeleteSpellCallback);
        addEventListener("GetAllProfilesCallback", handleGetAllProfilesCallback);
        addEventListener("GetAllItemsCallback", handleGetAllItemsCallback);
        addEventListener("GetAllSpellsCallback", handleGetAllSpellsCallback);
        addEventListener("InitializeReactCallback", handleInitializeRealmCallback);
        addEventListener("ExecuteFunctionCallback", handleExecuteFunctionCallback);
        addEventListener("GenerateNewIdCallback", handleGenerateNewIdCallback);
        addEventListener("OpenIndexDBCallback", handleOpenIndexDBCallback);
        addEventListener("SaveImageCallback", handleSaveImageCallback);
        addEventListener("DownloadImageCallback", handleDownloadImageCallback);
        addEventListener("LoadImageCallback", handleLoadImageCallback);
        addEventListener("HasImageCallback", handleHasImageCallback);
        addEventListener("ReactRefreshCallback", handleRealmRefreshCallback);
        addEventListener("SetClipboardCallback", handleSetClipboardCallback);
        addEventListener("GetClipboardCallback", handleGetClipboardCallback);
        addEventListener("OpenUrlCallback", handleOpenUrlCallback);
        addEventListener("GoogleAuthCallback", handleGoogleAuthCallback);
        addEventListener("GoogleLogoutCallback", handleGoogleLogoutCallback);
        addEventListener("GoogleIsSignedInCallback", handleGoogleIsSignedInCallback);
        window.addEventListener('resize', handleResize);
        window.addEventListener('web3glConnected', handleWebGlConnected);
        return () => {
            removeEventListener("LoginInAnonymousCallback", handleLoginInAnonymousCallback);
            removeEventListener("LoginInEmailPasswordCallback", handleLoginEmailPasswordCallback);
            removeEventListener("LoginUserPassCallback", handleLoginUserPassCallback);
            removeEventListener("RegisterEmailPasswordCallback", handleRegisterEmailPasswordCallback);
            removeEventListener("ReactSaveCallback", handleRealmSaveCallback);
            removeEventListener("ReactDeleteProfileCallback", handleRealmDeleteProfileCallback);
            removeEventListener("ReactDeleteItemCallback", handleRealmDeleteItemCallback);
            removeEventListener("ReactDeleteSpellCallback", handleRealmDeleteSpellCallback);
            removeEventListener("GetAllProfilesCallback", handleGetAllProfilesCallback);
            removeEventListener("GetAllItemsCallback", handleGetAllItemsCallback);
            removeEventListener("GetAllSpellsCallback", handleGetAllSpellsCallback);
            removeEventListener("InitializeReactCallback", handleInitializeRealmCallback);
            removeEventListener("ExecuteFunctionCallback", handleExecuteFunctionCallback);
            removeEventListener("GenerateNewIdCallback", handleGenerateNewIdCallback);
            removeEventListener("OpenIndexDBCallback", handleOpenIndexDBCallback);
            removeEventListener("SaveImageCallback", handleSaveImageCallback);
            removeEventListener("LoadImageCallback", handleLoadImageCallback);
            removeEventListener("HasImageCallback", handleHasImageCallback);
            removeEventListener("ReactRefreshCallback", handleRealmRefreshCallback);
            removeEventListener("SetClipboardCallback", handleSetClipboardCallback);
            removeEventListener("GetClipboardCallback", handleGetClipboardCallback);
            removeEventListener("OpenUrlCallback", handleOpenUrlCallback);
            removeEventListener("GoogleAuthCallback", handleGoogleAuthCallback);
            removeEventListener("GoogleLogoutCallback", handleGoogleLogoutCallback);
            removeEventListener("GoogleIsSignedInCallback", handleGoogleIsSignedInCallback);
            window.removeEventListener("web3glConnected", handleWebGlConnected);
            window.removeEventListener('resize', handleResize);
        };
    }, [ 
        isLoaded, 
    ]);

    return (
        <Fragment>
            {!isLoaded && (
                <div style={{
                    width: "100%", height: "100%", flexDirection: "row",
                    alignContent: "space-between",
                    justifyContent: "center", display: "flex"
                }}>
                    <p>Loading Application... {Math.round(loadingProgression * 100)}%</p>
                </div>
            )}

            <div style={{
                width: "100%", height: "100%", flexDirection: "row",
                alignContent: "space-between",
                justifyContent: "center", display: "flex",
                backgroundColor: "black"
            }}>
                <Unity
                    unityProvider={unityProvider}
                    style={{
                        visibility: isLoaded ? "visible" : "hidden",
                        width: width,
                        height: height,
                    }}
                />
            </div>
        </Fragment>
    );
}

export default App;
